import './polyfills';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_MODE || 'local',
  release: import.meta.env.VITE_SENTRY_RELEASE,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", /^https:\/\/back\.hubins\.com/],
  // Session Replay
  // replaysSessionSampleRate: 0.1,
  // replaysOnErrorSampleRate: 1.0,
  beforeSend(event, hint) {
    const status = hint?.originalException?.response?.status;
    const code = event?.exception?.values?.[0]?.mechanism?.data?.code
      || event?.extra?.graphql?.errors?.[0]?.extensions?.code;
    if (status === 401 || code === 'UNAUTHENTICATED') return null;
    return event;
  },
});

const container = document.getElementById('app');
const root = createRoot(container);
root.render(<App />);
